import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import ComponentTitle from './ComponentTitle';
import IFrame from './IFrame';
import VideoPlayer from '../media/VideoPlayer';
import { unescapeScript } from 'utils/StringUtils';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';
import convert from 'xml-js';

let loadedScriptCodeBlockId = [];

class CodeBlock extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    title: PropTypes.string,
    showTitle: PropTypes.bool,
    type: PropTypes.oneOf(['iframe', 'inline']),
    iframeOptions: PropTypes.shape({
      url: PropTypes.string.isRequired,
      dimensionsPerBreakpoint: PropTypes.object,
      enableFullScreen: PropTypes.bool,
      sandbox: PropTypes.string,
      showScrollBar: PropTypes.bool
    }),
    showBorder: PropTypes.bool,
    borderColor: PropTypes.string,
    content: PropTypes.string,
    titleType: PropTypes.string
  }

  static defaultProps = {
    FRN_rawResponses: [],
    showTitle: false,
    type: 'iframe',
    showBorder: false,
    titleType: TITLE_TYPE.MODULE_TITLE
  }

  componentDidMount() {
    const interval = setInterval(
      () => {
        const parentVideoTags = document.querySelectorAll('.CodeBlock .vjsVideoCanvas');
        if (parentVideoTags.length > 0) {
          let count = 0;
          const length = parentVideoTags.length;

          for (let tag of parentVideoTags) {
            const videoTag = tag.querySelector('video');

            if (videoTag && videoTag.src) {
              // get thumnail of video
              const poster = tag.querySelector('.vjs-poster');
              const style = poster.currentStyle || window.getComputedStyle(poster, false);
              const thumbnail = style.backgroundImage.slice(4, -1).replace(/"/g, '');

              // create galleryVideo object
              const galleryVideo = this._getGalleryVideo(tag.parentNode);

              // create VideoPlayer component
              const videoPlayer = this._renderVideoPlayer(videoTag.src, thumbnail, galleryVideo);

              // replace old video widget by VideoPlayer
              ReactDOM.render(videoPlayer, tag);

              count++;
            }
          }

          if (count === length) {
            clearInterval(interval);
          }
        }
      }, 2000);


    setTimeout(
      () => {
        clearInterval(interval);
      }, 20000);
  }

  _renderVideoPlayer(src, thumbnail, galleryVideo) {
    const dataOfGallery = [
      { data: { features: galleryVideo } }
    ];
    const isSlider = galleryVideo.length > 0;
    const sliderProps = { showListByline: false };
    const maxLimit = isSlider ? galleryVideo.length : 1;

    return (
      <VideoPlayer
        destinationUrl={src}
        defaultThumbnail={thumbnail}
        autoPlayVideo={false}
        FRN_rawResponses={dataOfGallery}
        isSlider={isSlider}
        showAdditionalVideos={isSlider}
        sliderProps={sliderProps}
        maxLimit={maxLimit}
      />
    );
  }

  _getGalleryVideo(parentNode) {
    const parentGalleryTags = parentNode.querySelectorAll(`.wn-gallery`);
    const galleryVideo = [];
    //get list video
    
    if (parentGalleryTags.length > 0) {
      for (let tag of parentGalleryTags) {
        const videoPages = tag.querySelectorAll('.video-page') || [];

        if (videoPages.length > 0) {
            for (let i = 0; i < videoPages.length; i++) {
              const videos = tag.querySelectorAll(`.video-page-${i + 1} a`);
              
              /* eslint-disable */
              _.forEach(videos, (video) => {
                // extract data and build video info
                const href = video.href;
                const tagVideo = video.getElementsByTagName('li')[0];
                const idVideo = tagVideo.id.split('_')[1];
                const slug = href.split(`${idVideo}/`)[1];
                const imgTag = tagVideo.getElementsByTagName('img')[0];
                const titleTag = tagVideo.getElementsByClassName('title')[0].innerHTML;
                const infoVideo = {
                  abstractimage: {
                    filename: imgTag.src
                  },
                  link: href,
                  headline: titleTag,
                  type: 'clip',
                  id: idVideo,
                  seo: { pageurl: slug},
                  window: {
                    showscrollbar: true
                  }
                };
                galleryVideo.push(infoVideo);
              });
            }
        }

        // remove wn gallery here
        tag.remove();
      }
    }

    return galleryVideo;
  }

  _cleanXmlObj(xmlBlock) {
    return ({
      ID: xmlBlock.ID._text,
      HEADLINE: xmlBlock.HEADLINE._cdata,
      BODY: xmlBlock.BODY._cdata,
    });
  }

  _buildDataForCodeBlock(data) {
    let { data: dataStr = {} } = data;
    let id, headline, bodyCodeBlock;

    // handle for XML string cases
    try {
      if (typeof dataStr === 'string') {
        dataStr = convert.xml2js(dataStr, {compact: true});
        dataStr.XMLBLOCK = this._cleanXmlObj(dataStr.XMLBLOCK);
      }
    } catch (error) {
      console.log(error);
    }

    if (_.get(dataStr, 'XMLBLOCK.BODY')) {
      const { XMLBLOCK = {} } = dataStr;
      return [{
        id: XMLBLOCK.ID || _.uniqueId(),
        headline: XMLBLOCK.HEADLINE || '',
        bodyCodeBlock: XMLBLOCK.BODY,
      }];
    }

    // handle for json cases
    const codeBlockList = [];
    const featuresData = dataStr.features || [];
    featuresData.forEach(item => {
      headline = item.headline || '';
      bodyCodeBlock = item.body;
      id = item.id || _.uniqueId();
      
      if (bodyCodeBlock) {
        codeBlockList.push({
          id,
          headline,
          bodyCodeBlock,
        });
      }
    });
  
    return codeBlockList;
  }

  render() {
    const {
      FRN_rawResponses,
      title,
      showTitle,
      showBorder,
      borderColor,
      content = '',
      type,
      iframeOptions,
      titleType
    } = this.props;

    if (type === 'iframe') {
      return (
        <IFrame title={showTitle ? title : ''} showBorder={showBorder} borderColor={borderColor} {...iframeOptions} />
      );
    }

    if (_.isEmpty(FRN_rawResponses)) {
      return null;
    }

    const codeBlockList = this._buildDataForCodeBlock(FRN_rawResponses[0]);

    return (
      <div>
        {
          codeBlockList.map((item, i) => {
            const {
              bodyCodeBlock,
              headline,
              id
            } = item;
            
            return (
            <InlineCode
              codeBlock={bodyCodeBlock}
              showTitle={showTitle}
              title={title}
              showBorder={showBorder}
              borderColor={borderColor}
              content={content}
              titleType={titleType}
              headline={headline}
              domContainerId={`divCodeBlock_${id}`}
              key={i}
            />
            );
          })
        }
      </div>
    );
  }
}

class InlineCode extends Component {
  static propTypes = {
    codeBlock: PropTypes.string,
    title: PropTypes.string,
    showTitle: PropTypes.bool,
    showBorder: PropTypes.bool,
    borderColor: PropTypes.string,
    content: PropTypes.string,
    titleType: PropTypes.string,
    headline: PropTypes.string,
    domContainerId: PropTypes.string
  }

  componentDidMount() {
    const {
      codeBlock,
      content,
      domContainerId
    } = this.props;

    if (loadedScriptCodeBlockId.indexOf(domContainerId) < 0) {
      const $ = window['$'];

      // remove html from ssr
      $(`#${domContainerId}`).empty();

      const postscribe = require('postscribe');
      // use postscribe to allow the script execute document.write when loading page asynchronously 
      postscribe(`#${domContainerId}`, codeBlock);
      
      /**
      ** Because the script tags aren't working when using dangerouslySetInnerHTML.
      *  So for shortest way, we use jquery to append the code to the container
      *  Script tags in `content` need to be unescaped to append in
      */
      $(`#${domContainerId}`).append(unescapeScript(content));

      loadedScriptCodeBlockId.push(domContainerId);
    }
  }

  componentWillUnmount() {
    const {
      domContainerId
    } = this.props;

    if (document) {
      const currentNode = document.getElementById(domContainerId);

      if (currentNode) {
        while (currentNode.hasChildNodes()) {
          currentNode.removeChild(currentNode.lastChild);
        }
      }
    }
  }

  render() {    
    const {
      title,
      showTitle,
      showBorder,
      borderColor,
      titleType,
      headline,
      domContainerId,
      codeBlock
    } = this.props;

    const containerStyle = {};

    if (showBorder && borderColor) {
      containerStyle.border = `1px solid ${borderColor}`;
    }

    return (
      <div className="CodeBlock">
        {
          showTitle && <ComponentTitle titleType={titleType} title={title || headline} />
        }
        <div id={`${domContainerId}`} key={`${domContainerId}`}
          className="CodeBlock-container"
          style={containerStyle}
          dangerouslySetInnerHTML={{ __html: codeBlock }}
        />
      </div>
    );
  }
}

export default CodeBlock;



// WEBPACK FOOTER //
// ./app/components/shared/CodeBlock.js